import { Heading, HeadingVariants } from '@/ui'
import { PlaidLinkContextProvider } from '../../connected-financial-institutions-card/plaid/LinkContext'
import { PlaidErrorDialog } from '../../connected-financial-institutions-card/plaid/ErrorDialog'
import { DuplicateInstitutionDialog } from '../../connected-financial-institutions-card/DuplicateInstitutionDialog'
import { BankAccountsList } from './BankAccountsList'
import { PlaidLauncher } from './PlaidLauncher'

export const FinancialInstitutionsTab = () => {
  return (
    <PlaidLinkContextProvider>
      <Heading variant={HeadingVariants.H1}>Manage bank accounts</Heading>
      <div className="mt-8">
        <BankAccountsList />
      </div>
      <PlaidLauncher />
      <DuplicateInstitutionDialog />
      <PlaidErrorDialog />
    </PlaidLinkContextProvider>
  )
}
